/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-plusplus */
import React, { useState, useEffect, useRef, useContext } from 'react';
import Select from 'react-select';
import _ from 'lodash';
import AddIcon from '@material-ui/icons/Add';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Button, TextField, Grid, Chip } from '@material-ui/core';
import styles from '../../styles/Layout.module.css';
import Loading from '../../components/loading/Loading';
import TableContract from '../../components/tables/contract/TableContract';
// import ContractsTable from './ContractsTable';
import api from '../../service/axios/api';
import routing from '../../service/routes/routing';
import MyButton from '../../components/button/MyButton';
import PermissionComponent from '../../components/permissionComponent/PermissionComponent';
import UserRoles from '../../service/acl/UserRoles';
import FlashContext from '../../components/contexts/FlashContext';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: 10,
    margin: 0,
  },
  chip: {
    margin: 10,
  },
  textField: {
    // width: '90%',
  },
  input: {
    backgroundColor: '#fff',
    marginTop: 0,
    // color: 'white',
  },
});

export default function Contract() {
  const history = useHistory();
  const { t } = useTranslation();
  const { notifyError } = useContext(FlashContext);
  const [loading, setLoading] = useState(false);
  const [loadingXlsx, setLoadingXlsx] = useState(false);
  const [chipData, setChipData] = useState([]);
  const [searchType, setSearchType] = useState();
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [statusSelected, setStatusSelected] = useState({
    label: t('contract.filters.all'),
    value: '',
  });
  const [productSelected, setProductSelected] = useState({
    label: t('contract.filters.all'),
    value: '',
  });
  const searchRef = useRef(null);
  const [options, setOptions] = useState([
    { label: t('contract.filters.group'), value: 'groupName' },
    { label: t('contract.filters.cnpj'), value: 'cnpj' },
    { label: t('contract.filters.rz'), value: 'billed' },
  ]);

  const [massChangeForm, setMassChangeForm] = useState({
  productType: null,
  fee: null,
  value: '',
});

const massChangeFieldOptionsFee = [
  { label: 'Valor de Carga Mínima', value: 'minimum_load_amount' },
  { label: 'Carga inferior ao Mínimo', value: 'below_minimum_load_fee' },
  { label: 'Emissão de 2ª Via', value: 'reissue_fee' },
  { label: 'Desbloqueio de senha', value: 'unlock_fee' },
  { label: 'Taxa de Estorno', value: 'chargeback_fee' },
  { label: 'Saque', value: 'bank_withdraw_fee' },
  { label: 'IR', value: 'ir_fee' },
];

const massChangeFieldOptionsProductType = [
  { label: 'Card', value: 'Card' },
  { label: 'Transfer', value: 'Transfer' },
];

const massChangeStatusOptions = [
  { label: 'Ativo', value: true },
  { label: 'Inativo', value: false },
];

  const [page, setPage] = useState(0);
  const [itens, setItens] = useState(500);

  const [openMassChangeModal, setOpenMassChangeModal] = useState(false);
  
/* eslint-disable */
  const massChange = async (data) => {
    try {
      const payload = {
        product_type: data.productType?.value,
        taxas: {
          [data.fee?.value]: Number(data.value),
        },
      };

      const res = await api.contract.massChange(payload);
    } catch (error) {
      notifyError(error.message);
    }
  };
  /* eslint-disable */

 const downloadExcel = async () => {
    try {
      setLoadingXlsx(true);
      const res = await api.contract.generateXlsx([])
      const blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      let fileName = 'contratos.xlsx'

      const contentDisposition =
        res.headers?.['content-disposition'] ||
        res.headers?.['Content-Disposition']

      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        )

        if (match?.[1]) {
          fileName = match[1].replace(/['"]/g, '').trim()
        }
      }
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')

      link.href = url
      link.download = fileName

      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      setLoadingXlsx(false);
    } catch (error) {
      setLoadingXlsx(false);
      notifyError(error.message)
    }
  }

  const downloadExecutorPedidos = async() => {
    try {
      setLoadingXlsx(true);
      const res = await api.contract.executorPedidosXlsx([])
      const blob = new Blob([res.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })

      let fileName = 'contratos.xlsx'

      const contentDisposition =
        res.headers?.['content-disposition'] ||
        res.headers?.['Content-Disposition']

      if (contentDisposition) {
        const match = contentDisposition.match(
          /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
        )

        if (match?.[1]) {
          fileName = match[1].replace(/['"]/g, '').trim()
        }
      }
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')

      link.href = url
      link.download = fileName

      document.body.appendChild(link)
      link.click()

      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
      setLoadingXlsx(false);
    } catch (error) {
      setLoadingXlsx(false);
      notifyError(error.message)
    }
  };

  const search = extra => {
    setLoading(true);
    const cancel = new AbortController();
    api.contract
      .get(
        productSelected.value,
        statusSelected.value,
        extra,
        itens,
        page + 1,
        cancel,
        chipData,
      )
      .then(res => {
        const list = [];
        res.docs.forEach(r => {
          list.push({
            id: r?.contract_id,
            campaing: r?.Contract?.campaign,
            group: r?.Contract?.group_name,
            cnpj: r?.LegalEntity?.cnpj,
            rz: r?.LegalEntity?.company_name,
            product: r?.Contract?.product_type,
            status: r?.Contract?.is_active,
            contractLink: r?.Contract?.pdf_file,
            contractLinkFourSign: r?.Contract.doc4sign_file,
            userName: r?.Contract?.ContractUser[0]?.User?.name || '-',
            userMobile: r?.Contract?.ContractUser[0]?.User?.mobile || '-',
            admRate: r?.Contract?.administration_rate || '-',
            commercialAgent: r?.Contract?.ContractCommercialAgent[0]?.CommercialAgent?.company_name || '-',
            paymentBank: r?.Contract?.BankAccount?.bank || '-'
          });
        });
        setTotal(res.total);
        setData(list);
        setLoading(false);
      })
      .catch(error => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    search();
  }, [itens, page, statusSelected, productSelected]);

  return (
    <>
      <Loading open={loading} msg={t('contract.searchMsg')} />
      <Loading open={loadingXlsx} msg="Gerando planilha..." />
      <div className="col-sm-12" style={{ marginTop: 50 }}>
        <div
          className="col-sm-12"
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'start',
          }}
        >
          <div>
            <p
              className={styles.textMenu}
              onKeyDown={() => history.push(routing.dashboard)}
              onClick={() => history.push(routing.dashboard)}
            >
              {t('initialMenu')}
            </p>
          </div>
        </div>
        <div
          className="col-sm-12"
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <h4 className={styles.textTitle}>{t('contract.label')}</h4>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <MyButton
              style={{ marginRight: 50 }}
              onClick={downloadExecutorPedidos}
              label="Executor Pedidos"
            />
            <PermissionComponent role={UserRoles.CONTRACT_NEW}>
              <MyButton
                style={{ marginRight: 50 }}
                // onClick={() => setOpenModal(true)}
                onClick={() => history.push(routing.newContract)}
                label={t('contract.newContractBtn')}
              />
            </PermissionComponent>
          </div>
        </div>
      </div>
      <Grid container spacing={3}>
        <Grid
          item
          xs={12}
          sm={12}
          style={{ display: 'flex', justifyContent: 'space-between' }}
        />
        <Grid item xs={12} sm={12}>
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'end',
          }}>
            <MyButton
              style={{ marginRight: 50, /* backgroundColor: '#1D6F42', color: 'white' */ }} 
              onClick={downloadExcel}
              label="Exportar Excel"
            />
            <MyButton
              style={{ marginRight: 50 }}
              onClick={() => setOpenMassChangeModal(true)} 
              label="Alteração em Massa"
            />
          </div>
          <TableContract
            data={data}
            setData={setData}
            totalPages={total}
            page={page}
            setPage={setPage}
            itens={itens}
            setItens={setItens}
            setStatus={setStatusSelected}
            product={productSelected}
            setProduct={setProductSelected}
            chipData={chipData}
            setChipData={setChipData}
            find={search}
          />
        </Grid>
      </Grid>
      {openMassChangeModal && (
      <div
        role="presentation"
        onKeyDown={(e) => e.key === 'Escape' && setOpenMassChangeModal(false)}
        onClick={() => setOpenMassChangeModal(false)}
        style={{
          position: 'fixed',
          top: 0, left: 0,
          width: '100vw', height: '100vh',
          backgroundColor: 'rgba(0,0,0,0.5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
        }}
      >
        {/* Card interno (div interna) - linha 262 */}
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="mass-change-title"
          onKeyDown={e => e.stopPropagation()}
          onClick={e => e.stopPropagation()}
          style={{
            backgroundColor: '#fff',
            borderRadius: 8,
            padding: 32,
            minWidth: 350,
            boxShadow: '0 4px 24px rgba(0,0,0,0.2)',
            display: 'flex',
            flexDirection: 'column',
            gap: 16,
          }}
        > 
          
          <h5 id="mass-change-title" style={{ margin: 0 }}>Alteração em Massa</h5>
          <p style={{ color: '#666', margin: 0, fontSize: 14 }}>
            Selecione o campo e o novo valor a ser aplicado em todos os contratos filtrados.
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {/* Campo a alterar */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <label style={{ fontSize: 12, color: '#666', marginBottom: 4, display: 'block' }}>
                Campo a alterar
              </label>
              <Select
                  placeholder="Selecione o tipo de produto"
                  options={massChangeFieldOptionsProductType}
                  value={massChangeForm.productType}
                  onChange={selected =>
                    setMassChangeForm(prev => ({ ...prev, productType: selected, value: '' }))
                  }
                  styles={{
                      menu: (base) => ({        
                        ...base,
                        zIndex: 9999,
                        borderRadius: 8,
                      }),
                    }}
                />

                <Select
                    placeholder="Selecione a taxa"
                    options={massChangeFieldOptionsFee}
                    value={massChangeForm.fee}
                    onChange={selected =>
                      setMassChangeForm(prev => ({ ...prev, fee: selected, value: '' }))
                    }
                    styles={{
                      menu: (base) => ({        // container da lista
                        ...base,
                        zIndex: 9999,
                        borderRadius: 8,
                      }),
                    }}
                  />
            </div>

            {/* Valor — muda conforme o campo s elecionado */}
            {massChangeForm.field?.value === 'is_active' ? (
              <div>
                <label style={{ fontSize: 12, color: '#666', marginBottom: 4, display: 'block' }}>
                  Novo status
                </label>
                <Select
                  placeholder="Selecione o status..."
                  options={massChangeStatusOptions}
                  value={massChangeStatusOptions.find(o => o.value === massChangeForm.value) || null}
                  onChange={selected =>
                    setMassChangeForm(prev => ({ ...prev, value: selected.value }))
                  }
                />
              </div>
            ) : (
              <TextField
                label="Novo valor"
                variant="outlined"
                fullWidth
                size="small"
                value={massChangeForm.value}
                onChange={e =>
                  setMassChangeForm(prev => ({ ...prev, value: e.target.value }))
                }
              />
            )}
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12, marginTop: 8 }}>
            <Button
              variant="outlined"
              onClick={() => {
                setOpenMassChangeModal(false);
                setMassChangeForm({ field: null, value: '' });
              }}
            >
              Cancelar
            </Button>
            <MyButton
              label="Confirmar"
              disabled={!massChangeForm.fee || !massChangeForm.productType || massChangeForm.value === ''}
              onClick={() => {
                massChange(massChangeForm);
                setOpenMassChangeModal(false);
                setMassChangeForm({ field: null, value: '' });
              }}
            />
          </div>
        </div>
      </div>
    )}    
    </>
  );
}
